import React, { useEffect, useState } from 'react';
import { useStyles } from '../../../../../styles/popupStyles';
import { Typography } from '@material-ui/core';
import { IConfigData } from '../../../../../interfaces';

interface DependencyFilesItem {
  label: string;
  value: string[] | undefined;
}

const DependencyFilesSection = (props: IConfigData) => {
  const classes = useStyles();
  const [detailsArr, setDetailsArr] = useState<DependencyFilesItem[]>([]);

  useEffect(() => {
    loadDetailsArray();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const loadDetailsArray = () => {
    setDetailsArr([
      {
        label: 'File Path:',
        value: props.config?.configurationFiles,
      },
    ]);
  };

  return (
    <div className={classes.sectionContainer}>
      <Typography className={classes.sectionHeading}>
        Dependency Files
      </Typography>
      <div>
        {detailsArr.map((item, index) => (
          <div className={classes.labelAndValue}>
            <div className={classes.label} key={index}>
              {item.label}
            </div>
            <div>
              {item.value?.map((file: any, index: number) => (
                <div key={index}>{file}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DependencyFilesSection;
